import React, { useEffect, useState } from 'react';
import axios from 'axios'
import {getCookie} from '../../common/utils/auth'
import { Table, Space, Spin, Button } from 'antd';
import { config } from "enviroment.js"
import "antd/dist/antd.css";
import './Admin.scss';
import AdminPageHeader from './AdminPageHeader'

const columns = [
  {
    title: 'First Name',
    dataIndex: 'first_name',
    key: 'first_name',
  },
  {
    title: 'Last Name',
    dataIndex: 'last_name',
    key: 'last_name',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Role',
    dataIndex: 'role',
    key: 'role',
  },
  {
    title: 'Actions',
    key: 'action',
    render: (text, record) => (
      <Space size="middle">
        <a href={'/admin/users/' + record.id}>Edit</a>
      </Space>
    ),
  },
];


const UserListView = () => {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState({ status: true, type: 'page' })
  const [error, setError] = useState({ status: false })

  useEffect(() => {
		axios.get(config.raUrl + `/admin/users/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getCookie('token')}`
      }
    })
			.then((res) => {
        setUsers(res.data)
        setLoading({ status: false })
			}).catch((err) => {
        console.log("error caught: ", err.response)
        let errorMessage = {
          status: true,
          text: 'Ooops!',
          sub: 'Something went wrong.'
        }
        if (err.response.status === 401) {
          errorMessage.text = 'Unauthorized'
          errorMessage.sub = 'You are not authorized to view this page.'
        }
        setError(errorMessage)
        setLoading({ status: false })
			})
  }, [])

  return (
    <Spin spinning={loading.status} size="large" className={loading.status && loading.type}>
      {error.status
        ? (
          <>
          <div className="error-container">
            <div className="error-text">{error.text}</div>
            <div className="error-sub">{error.sub}</div>
          </div>
          </>
        ) : (
          <>
          <AdminPageHeader
            title="Users"
            extra={
              [<Button key="1" href="/admin/users/create">Add User</Button>]
            }
          />
          <Table dataSource={users} columns={columns} rowKey="id" />
          </>
        )
      }
    </Spin>
  )
}
export default UserListView;
